import appClient from '../../common/services/AppClient';
import { endpoints } from '../../../config';

export default class SchemaGeneratorService {
    async generateJsonSchemaFromPydantic(pydanticModelString: string) {
        const url = endpoints.manageUrl + 'schema-generator/generate-json-schema-from-pydantic';

        return appClient.post<{ jsonSchema: string }>(url, { pydanticModelString });
    }
}
